import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/verified.svg'


const _withScopeId = n => (_pushScopeId("data-v-e48e4ede"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main tw-text-center tw-space-y-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "verify_tag" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "verify_icon" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "Verified")
], -1))
const _hoisted_3 = { class: "payment-wallet-wrapper tw-flex tw-flex-col tw-items-center tw-space-y-2" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "workstation_content" }
const _hoisted_6 = { class: "tw-text-lg tw-font-bold tw-text-gray-800" }
const _hoisted_7 = { class: "tw-text-sm tw-text-gray-500" }
const _hoisted_8 = { class: "tw-flex tw-items-center tw-space-x-1 rating__wrapper" }
const _hoisted_9 = { class: "qr__code tw-flex tw-flex-col tw-items-center tw-space-y-2" }
const _hoisted_10 = {
  key: 0,
  class: "tw-relative"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-items-center tw-justify-center tw-gap-3" }, null, -1))

import GeneralDialog from "@/core/components/modals/GeneralDialog.vue";
import { ref, onMounted, nextTick } from "vue";
import QRCodeStyling from "qr-code-styling";
import { useStore } from "vuex";
import { WORKSTATION } from "@/store/modules/workstation";
import {
  displayToastMessage,
  getEnvironment,
  setDirectStoragePathToImage,
} from "@/core/utils/common";
import { getCurrentInstance } from "vue";
import { BusinessDetailTypeEnum } from "@/core/enums/RolesEnum";
import { Environment } from "@/config";
import { computed } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentWalletModal',
  props: {
  data: {
    default: null,
    type: Object,
  },
  getAverageOfAllProjectReview: {
    type: null,
  },
  linkData: {},
},
  emits: ["on-cancel", "on-save"],
  setup(__props, { emit: __emit }) {

const internalInstance = getCurrentInstance();
const emits = __emit;

const props = __props;
const loading = ref(false);
const store = useStore();
const qrCanvas = ref<null>(null);
const qrVisible = ref(true);
const walletImage = ref("");
const qrCode = ref<QRCodeStyling | null>(null);

const onCloseModal = () => {
  emits("on-cancel");
};

const toggleQrVisibility = () => {
  qrVisible.value = !qrVisible.value;

  if (qrVisible.value) {
    nextTick(() => {
      generateQRCode();
    });
  }
};

const generateQRCode = () => {
  let baseUrl = "http://localhost:3000";

  const environment = getEnvironment();

  if (environment === Environment.PRODUCTION) {
    baseUrl = "https://api.iknowa.com";
  } else if (environment === Environment.STAGING) {
    baseUrl = "https://api.lucythepalm.com";
  } else if (environment === Environment.DEVELOPMENT) {
    baseUrl = "https://api.barrythebonsai.com";
  }
  const url = `${baseUrl}/workstation-link-tree/payment/${props.data.workStationLinkId}`;

  if (!qrCode.value) {
    qrCode.value = new QRCodeStyling({
      type: "canvas",
      shape: "square",
      width: 250,
      height: 250,
      data: url,
      image: require("@/assets/images/iknowa-logo.svg"),
      margin: 10,
      qrOptions: {
        // typeNumber: "0",
        mode: "Byte",
        errorCorrectionLevel: "Q",
      },
      imageOptions: {
        saveAsBlob: true,
        hideBackgroundDots: true,
        imageSize: 0.6,
        margin: 2,
      },
      dotsOptions: {
        type: "extra-rounded",
        color: "#000000",
      },
      backgroundOptions: {
        color: "#ffffff",
      },
      cornersSquareOptions: {
        type: "extra-rounded",
        color: "#000000",
      },
      cornersDotOptions: {
        // type: "",
        color: "#000000",
      },
    });
  } else {
    qrCode.value.update({ data: url });
  }

  if (qrCanvas.value) {
    qrCode.value.append(qrCanvas.value);
  }
};
const getWorkStationImage = (imgUrl: any) => {
  if (!imgUrl)
    return require("@/assets/images/workstation-trade-link-image-2.png");

  return setDirectStoragePathToImage(imgUrl);
};
const workStationType = (businessType: string) => {
  return businessType === BusinessDetailTypeEnum.LIMITED_COMPANY
    ? "LTD Company"
    : "Sole Trader";
};
const getWalletURl = () => {
  let baseUrl = "http://localhost:3000";

  const environment = getEnvironment();

  if (environment === Environment.PRODUCTION) {
    baseUrl = "https://api.iknowa.com";
  } else if (environment === Environment.STAGING) {
    baseUrl = "https://api.lucythepalm.com";
  } else if (environment === Environment.DEVELOPMENT) {
    baseUrl = "https://api.barrythebonsai.com";
  }
  const url = `${baseUrl}/workstation-link-tree/payment/${props.data.workStationLinkId}`;
  return url;
};
const detectDeviceType = computed(() => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  )
    ? true
    : false;
});

const openWallet = async () => {
  const url = getWalletURl();
  window.open(url, "_blank");
};
onMounted(() => {
  try {
    if (!props.data?.workStationLinkId) {
      displayToastMessage(
        internalInstance,
        "WorkStation Link not found.",
        "error"
      );
    }

    generateQRCode();
  } catch (error: any) {
    if (error.response) {
      const errorMessage =
        error.response.data.message ||
        "Something went wrong, please try again later.";
      displayToastMessage(internalInstance, errorMessage, "error");
    } else if (error.request) {
      displayToastMessage(
        internalInstance,
        "No response from server. Please try again later.",
        "error"
      );
    } else {
      displayToastMessage(internalInstance, `Error: ${error.message}`, "error");
    }
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_rating = _resolveComponent("v-rating")!

  return (_openBlock(), _createBlock(GeneralDialog, {
    class: "payment-wallet-modal",
    onOnClose: onCloseModal,
    width: "390px",
    "max-width": "100%",
    isShowCloseButton: false
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_btn, {
          class: "wallet_back_btn",
          variant: "text",
          onClick: onCloseModal
        }, {
          default: _withCtx(() => [
            _createTextVNode("Take Me Back")
          ]),
          _: 1
        }),
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              class: "workstation_img",
              src: 
                getWorkStationImage(__props.data.userWorkstationDetails.profileImage)
              ,
              loading: "lazy",
              alt: "workstation image"
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", _hoisted_6, _toDisplayString(__props.data.userWorkstationDetails.name), 1),
            _createElementVNode("p", _hoisted_7, _toDisplayString(workStationType(
                  __props.data.userWorkstationDetails?.user?.userBusinessDetails?.type
                )), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_v_rating, {
              length: 5,
              size: 32,
              value: __props.getAverageOfAllProjectReview,
              "active-color": "orange",
              color: "rgba(12, 15, 74, 0.26)",
              "empty-icon": "mdi-star",
              readonly: ""
            }, null, 8, ["value"]),
            _createElementVNode("p", null, _toDisplayString(__props.getAverageOfAllProjectReview) + " stars", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          (qrVisible.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", {
                  ref_key: "qrCanvas",
                  ref: qrCanvas,
                  class: "tw-border tw-rounded"
                }, null, 512)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", {
            class: "tw-text-base tw-text-[#4b4bff] tw-cursor-pointer tw-font-semibold tw-leading-[20.08px] tw-no-underline",
            onClick: toggleQrVisibility
          }, _toDisplayString(qrVisible.value ? "Hide QR Code" : "Show QR Code"), 1),
          (detectDeviceType.value)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 1,
                onClick: openWallet,
                class: "button button-orange tw-w-full"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Open Google Wallet ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _hoisted_11
    ]),
    _: 1
  }))
}
}

})